// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"79":"323f9d66","178":"2fd83843","408":"63ad6201","458":"8eaea757","488":"9a82b050","625":"675bfd48","658":"50a7d016","710":"f0ed41f0","735":"8b457856","797":"42cc3947","850":"dc06a47d","855":"23c04950"}[chunkId] + ".js";
};